module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/dq-vacant-property/dq-vacant-property.component.css
// module id = ./src/app/reports/dq-vacant-property/dq-vacant-property.component.css
// module chunks = main